import { Coffee, Heart, ShieldCheck } from "lucide-react";

const SPONSOR_URL = "https://buymeacoffee.com/xbow";

export default function SupportBanner({ compact = false }) {
  if (compact) {
    return (
      <a
        href={SPONSOR_URL}
        target="_blank"
        rel="noreferrer"
        data-testid="support-link-compact"
        className="hidden md:flex items-center gap-1.5 text-xs font-mono text-amber-700 hover:text-amber-800 border border-amber-200 hover:border-amber-300 bg-amber-50 hover:bg-amber-100 rounded-md px-3 py-1.5 transition-colors"
      >
        <Coffee className="h-3.5 w-3.5" />
        Support this project
      </a>
    );
  }

  return (
    <section
      data-testid="support-banner"
      className="panel p-6 md:p-7 mt-10 relative overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-30 pointer-events-none"
        style={{
          background:
            "transparent",
        }}
      />
      <div className="relative grid grid-cols-1 md:grid-cols-3 gap-6 items-center">
        <div className="md:col-span-2">
          <div className="overline mb-2 flex items-center gap-2">
            <Heart className="h-3 w-3 text-amber-700" />
            Keep this corner of the internet open
          </div>
          <h3 className="font-display text-xl md:text-2xl font-bold text-slate-900 leading-tight">
            Free for everyone. Made by{" "}
            <span className="text-amber-700">one human</span> who likes the open
            web.
          </h3>
          <p className="text-slate-700 text-sm md:text-base mt-3 leading-relaxed max-w-2xl">
            Every analysis here costs real LLM tokens, OSV/NVD bandwidth, and
            quiet weekends. If this tool saved you an hour - or a CVE Wednesday
            from going sideways -{" "}
            <span className="text-slate-900 font-semibold">support this project</span>{" "}
            so it stays free for the next defender after you.
          </p>
          <div className="mt-4 flex flex-wrap gap-3 items-center text-xs text-slate-600">
            <span className="flex items-center gap-1.5">
              <ShieldCheck className="h-3.5 w-3.5 text-emerald-700" />
              100% goes to compute + new features
            </span>
            <span className="text-slate-500">·</span>
            <span>No tracking pixels in this banner</span>
          </div>
        </div>
        <div className="flex flex-col items-stretch gap-3">
          <a
            href={SPONSOR_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="support-cta"
            className="flex items-center justify-center gap-2 bg-amber-300 hover:bg-amber-200 text-slate-900 px-5 py-3 rounded-md font-semibold transition-colors"
          >
            <Coffee className="h-4 w-4" />
            Support this project
          </a>
          <a
            href={SPONSOR_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="support-secondary"
            className="text-center text-xs font-mono text-slate-600 hover:text-amber-700 transition-colors"
          >
            via buymeacoffee.com/xbow
          </a>
        </div>
      </div>
    </section>
  );
}
